var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 931"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.71311 14.8304C2.35666 14.8304 2.87836 15.3521 2.87836 15.9956V20.6567C2.87836 20.9657 3.00113 21.2621 3.21966 21.4806C3.43818 21.6992 3.73457 21.8219 4.04361 21.8219H20.3572C20.6662 21.8219 20.9626 21.6992 21.1811 21.4806C21.3997 21.2621 21.5224 20.9657 21.5224 20.6567V15.9956C21.5224 15.3521 22.0441 14.8304 22.6877 14.8304C23.3312 14.8304 23.8529 15.3521 23.8529 15.9956V20.6567C23.8529 21.5838 23.4846 22.473 22.8291 23.1285C22.1735 23.7841 21.2843 24.1524 20.3572 24.1524H4.04361C3.11648 24.1524 2.22732 23.7841 1.57174 23.1285C0.916154 22.473 0.547852 21.5838 0.547852 20.6567V15.9956C0.547852 15.3521 1.06955 14.8304 1.71311 14.8304Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55028 9.34538C6.00534 8.89032 6.74314 8.89032 7.1982 9.34538L12.2005 14.3477L17.2028 9.34538C17.6579 8.89032 18.3957 8.89032 18.8507 9.34538C19.3058 9.80045 19.3058 10.5382 18.8507 10.9933L13.0245 16.8196C12.5694 17.2746 11.8316 17.2746 11.3766 16.8196L5.55028 10.9933C5.09522 10.5382 5.09522 9.80045 5.55028 9.34538Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2004 0.847473C12.844 0.847473 13.3657 1.36918 13.3657 2.01273V15.9958C13.3657 16.6394 12.844 17.1611 12.2004 17.1611C11.5569 17.1611 11.0352 16.6394 11.0352 15.9958V2.01273C11.0352 1.36918 11.5569 0.847473 12.2004 0.847473Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.e690791d7dd60e1360907421a7778208.svg";
export { ForwardRef as ReactComponent };